import firebase from "../../Config/fbConfig";

export const createItem = (item, completion) => {
    firebase.firestore().collection("items").add(item).then(res => {
        completion(res.id);
    }).catch(function (error) {
        completion(null);
    });
};

export const updateItem = (id, item, completion) => {
    firebase.firestore().collection("items").doc(id).update(item).then(res => {
        completion(true);
    }).catch(function (error) {
        completion(null);
    });
};

export const deleteItem = (id, completion) => {
    firebase.firestore().collection("items").doc(id).delete().then(res => {
        completion(true);
    }).catch(function (error) {
        completion(null);
    });
};

export const createShopItem = (id, itemId, item, completion) => {
    firebase.firestore().collection("shops").doc(id).collection("items").doc(itemId).set(item, { merge: true }).then(res => {
        completion(true);
    }).catch(function (error) {
        completion(null);
    });
};

export const updateShopItem = (id, itemId, item, completion) => {
    firebase.firestore().collection("shops").doc(id).collection("items").doc(itemId).update(item).then(res => {
        completion(true);
    }).catch(function (error) {
        completion(null);
    });
};

export const deleteShopItem = (id, itemId, completion) => {
    firebase.firestore().collection("shops").doc(id).collection("items").doc(itemId).delete().then(res => {
        completion(true);
    }).catch(function (error) {
        completion(null);
    });
};



// WEBPACK FOOTER //
// ./src/Store/Actions/item.js